module.exports = __webpack_public_path__ + "img/singpass.c6a1fda6.png";